import * as React from "react";
const SvgQonto = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 400 400",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 200v200h400V0H0zM98 88.5c41.8 6.3 77.2 36.3 90.3 76.5 2.2 6.6 5.7 23.8 5.7 27.7 0 1.9-5.7 1.6-16.5-.6-46.6-9.9-81.9-47.2-89-94.1-1.7-11.1-1.7-11-.7-11 .4 0 5 .7 10.2 1.5m215-.8c0 3.7-3.3 21.2-5 26.8-6.8 22-21.8 43.1-41 57.7-13.6 10.4-37.6 19.9-54.2 21.4-7.9.8-7.4 1.7-5.3-11.1 7.4-46 43.6-84.2 88-92.9 12.6-2.4 17.5-2.9 17.5-1.9M193.6 212.2c-2.5 24.4-14.4 48.8-33 67.4-13.4 13.3-27.8 22.3-45.1 27.9-7.3 2.4-27.3 6.1-28.1 5.2-.2-.2.1-4 .6-8.5 5.2-41.4 34.6-77.7 74.5-92.1 7.3-2.6 22.5-5.9 27.9-6l3.9-.1zm32.1-3.6c37.4 8.7 69 37.5 81.3 74.2 2.8 8.3 6.7 28.9 5.7 29.9-.3.2-4.9-.3-10.3-1.1-23.2-3.5-44-13.7-61-29.8-19.7-18.7-31.2-42-34.9-70.7l-.7-5.4 6.7.7c3.7.4 9.6 1.4 13.2 2.2"
}));
export default SvgQonto;
//# sourceMappingURL=Qonto.js.map